<template>
  <label
    class="f-input"
    :class="{ error: isHaveError && !isFocusedInput}"
  >
    <input
      type="text"
      v-bind="$attrs"
      :value="value"
      autocomplete
      v-on="inputListeners"
    >

    <div class="f-input-name">
      {{ label }}
    </div>

    <slot v-if="!isFocusedInput" />
  </label>
</template>

<script>
export default {
  name: 'BaseInput',
  inheritAttrs: false,
  props: {
    value: {
      type: [String, Number],
      required: true
    },
    label: {
      type: String,
      default: ''
    },
    isHaveError: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isFocusedInput: false
    };
  },
  computed: {
    inputListeners() {
      return Object.assign({},
        this.$listeners,
        {
          input: this.handleInputEvent,
          focus: this.handleFocusEvent,
          blur: this.handleBlurEvent
        }
      );
    }
  },
  methods: {
    handleInputEvent(event) {
      this.$emit('input', event.target.value);
    },
    handleFocusEvent() {
      this.isFocusedInput = true;
    },
    handleBlurEvent() {
      this.isFocusedInput = false;
    }
  }
}
</script>
